module.exports = __webpack_public_path__ + "static/logo-middle-red-4b542214f192ee0d9627463617e25ae7.svg";